<script lang="ts">
    import type {ViewLayout} from 'shared/layouts/grid-system/built-layout/types';
    import type {SvelteComponentConstructor} from 'core/types';
    import IconInfoBlockPart from 'shared/layouts/grid-system/built-layout/IconInfoBlockPart.svelte';
    import FullWidthDividerPart from 'shared/layouts/grid-system/built-layout/FullWidthDividerPart.svelte';
    import BuiltLayoutPart from 'shared/layouts/grid-system/built-layout/BuiltLayoutPart.svelte';

    export let layout: ViewLayout;
    export let supportedComponents: Record<string, SvelteComponentConstructor>;

    $: allSupportedComponents = {
        ...supportedComponents,
        fullWidthDivider: FullWidthDividerPart,
        iconInfoBlock: IconInfoBlockPart
    }
</script>

<div class="kp-layout" style:--main-gap={layout.settings.mainLayoutGap}>
    {#each layout.parts as part}
        <BuiltLayoutPart {part}
                      supportedComponents={allSupportedComponents}
                      layoutSettings={layout.settings}/>
    {/each}
</div>

<style lang="less">
    .kp-layout {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: var(--main-gap);
    }
</style>